import React from 'react';

import {
  SidebarIconButton,
  ToggleButtonWrapper,
} from 'app/components/general/DetailPage/RightSidebar/structure/StickyButtons';
import {useWidgetProps} from 'app/components/general/DetailPage/RightSidebar/structure/StickyIsOpenGateway';
import {useToggleWidgetIsOpen, useWidgetIsOpenState} from 'app/settings/hooks';
import {WidgetIsOpenPayloadType, WidgetNameLabel} from 'app/settings/slice';
import {gt} from 'app/utils/i18n';

import type {StickyMenuType} from 'app/components/general/DetailPage/RightSidebar/structure/types';
import type {DetailPageItemType} from 'app/components/general/DetailPage/types';
type Props<ItemType extends DetailPageItemType> = StickyMenuType<ItemType> & {
  icon: string;
  widgetName: WidgetIsOpenPayloadType['widgetName'];
  badgeContent?: number;
};

export const StickySidebarMenuButton = <ItemType extends DetailPageItemType>({
  object,
  icon,
  widgetName,
  badgeContent,
  buttonDelta,
}: Props<ItemType>) => {
  const toggleWidgetIsOpen = useToggleWidgetIsOpen();

  const widgetProps = useWidgetProps(object, widgetName);
  const isOpen = useWidgetIsOpenState(widgetProps);

  const onToggle = () => {
    toggleWidgetIsOpen(widgetProps);
  };
  if (isOpen) {
    return null;
  }
  return (
    <ToggleButtonWrapper buttonDelta={buttonDelta}>
      <SidebarIconButton
        tooltip={gt('Show %s', WidgetNameLabel[widgetName])}
        onClick={onToggle}
        badgeContent={badgeContent}
        icon={icon}
      />
    </ToggleButtonWrapper>
  );
};
